// extracted by mini-css-extract-plugin
module.exports = {"hero":"tag-module--hero--LNZK6","heroText":"tag-module--hero-text--KbIUW","stroke":"tag-module--stroke--1zJyO"};